import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'

import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'userclientmap',
    components: {
        VueElementLoading,
        Multiselect
    },
    data: function() {
        return {
          client : [],
          listclientdata : [],
          clientList : [],
          show : false,
          userclientid : '',
          iptrackData:'',
          isallclient: false,
          isDisabled : false,
          allCheckDisabled: false
        }
    },
    created: function() {
    },
    mounted() {
      var userdetailEncrypt = window.localStorage.getItem('userdetail')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.iptrackData = userdetail
      this.username = userdetail.username;
      if(this.$route.params.id==undefined){
        this.$router.push('/user');
      }else{
        var userid = this.$route.params.id;
        this.getUserClientMap(userid);
        this.getClientData();
    }
    },
    methods: {
      closeRegistration(){
        this.$router.push('/user');
      },
      getUserClientMap(userid){
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');

        this.input = ({
            userid: userid
        })

        this.show = true;
        axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getUserClientMap',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            }).then(result => {;
              this.show = false;
              if(result.data.result.userclient && result.data.result.userclient.length> 0 &&  result.data.result.userclient[0]["ClientMasterID"]=="0" && result.data.result.userclient[0]["CompanyName"] =="ALL"){
                this.client = [];
                this.isallclient = true;
                this.isDisabled = true;
              }else{
                this.client = result.data.result.userclient
              }
              this.userclientid = result.data.result.userclientid
            })
      },
      getClientData() {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = {};
        axios({
            method: 'GET',
            url: apiUrl.api_url + 'external/getclientlist',
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then(result => {
            this.clientList = result.data.clients.data;
          }, error => {
            console.error(error)
          })
      },
      saveUserClient(){
        let clientidarr = [];
        if(this.isallclient == false){
          for(var i = 0; i < this.client.length; i++){
            clientidarr[i] = this.client[i].ClientMasterID
          }
        }else{
          this.client = [];
          this.client.push({
            ClientMasterID: '0',
            CompanyName: 'ALL'
          });
          clientidarr.push(0);
        }

        this.input = ({
          userid : this.$route.params.id,
          clientid : clientidarr,
          createdby : this.username,
          userclient : this.client,
          userclientid : this.userclientid,
          modifiedby : this.username
        });

        axios({
            method: 'POST',
            url: apiUrl.api_url + 'saveUserClient',
            data: this.input
          }).then(result => {
            this.$alertify.success(result.data.result);
            iptrackerdetails.checkUserIP(this.iptrackData,'User Client Mapping Saved',this.$route.path,this.input,result.data);
            this.$router.push('/user');
          })
      },
      onSubmit: function(event) {
        this.$validator.validateAll().then((result) => {
            if(result){
              this.saveUserClient();
            }
        }).catch(() => {
            console.log('errors exist', this.errors)
        });
      },
      setAllClient(event){
        if(event.target.checked == true){
          this.isDisabled = true
        }else{
          this.isDisabled = false
        }
      },
      updateValueAction(){
        if(this.client && this.client.length> 0){
          this.allCheckDisabled = true
        }else{
          this.allCheckDisabled = false
        }
      }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/userclientmap/userclientmap.component.js